import { useTranslation } from 'react-i18next';
import { usePadronCounts } from '@/hooks/usePadronCounts';

/**
 * Estado del padrón: cuántas fichas hay y cuántas siguen sin reclamar.
 *
 * 🔴 Por qué esto y no el switch que pedía WP-U8-T6: el switch iba en `UsersAdminView`, pero esa
 * vista usa `useAdminUsers()`, que filtra por rol server-side — de ahí solo salen administradores,
 * no el padrón. (Matiz posterior: desde que se puede nombrar administrador a una ficha sin reclamar,
 * `useAdminUsers()` pide `includeUnclaimed: true`; siguen siendo administradores y siguen sin ser
 * las 34 821 fichas que el switch mostraría.) Y el otro consumidor del roster, `NotificationsTab`, lo usa para armar correos
 * de destinatarios: las fichas sin reclamar no tienen correo, así que ya se descartan solas. No
 * existe hoy ninguna pantalla donde el switch tuviera efecto visible.
 *
 * Lo que el switch resolvía de verdad —«¿cargó el padrón?»— se responde aquí, junto a la corrida
 * que lo carga, que es donde el administrador ya está mirando.
 */
export function PadronCard() {
  const { t, i18n } = useTranslation();

  const { data, isLoading, isError } = usePadronCounts();

  // 🔴 Con el idioma de la APLICACIÓN, no el del navegador. `toLocaleString()` sin argumento usa el
  // del navegador, así que con la aplicación en inglés y Windows en español el separador de miles
  // salía en español junto a una etiqueta en inglés. Mismo criterio que las fechas de `JobCard`.
  const num = (v: number) => v.toLocaleString(i18n.language);

  return (
    <div className="glass jobs-card">
      <div className="jobs-card-header">
        <span className="jobs-card-name">
          <i className="fas fa-id-card" aria-hidden="true" /> {t('jobs.padronTitle')}
        </span>
      </div>

      {isLoading && <div className="jobs-card-row"><span>{t('jobs.padronLoading')}</span></div>}
      {isError && <div className="jobs-card-row"><span>{t('jobs.padronError')}</span></div>}

      {data && (
        <>
          <div className="jobs-card-row">
            <span>{t('jobs.padronTotal')}</span>
            <strong>{num(data.total)}</strong>
          </div>
          <div className="jobs-card-row">
            <span>{t('jobs.padronUnclaimed')}</span>
            <strong>{num(data.sinReclamar)}</strong>
          </div>
          <p className="jobs-card-hint">{t('jobs.padronHint')}</p>
        </>
      )}
    </div>
  );
}
